import axios from "axios";
export const GET_DISCONNECT_SCHEDULES = "GET_DISCONNECT_SCHEDULES";
export const GET_DISCONNECT_SCHEDULES_RESPONSE = "GET_DISCONNECT_SCHEDULES_RESPONSE";
export const GET_DISCONNECT_SCHEDULES_FAIL = "GET_DISCONNECT_SCHEDULES_FAIL";

export const POST_DISCONNECT_SCHEDULE = "POST_DISCONNECT_SCHEDULE";
export const POST_DISCONNECT_SCHEDULE_RESPONSE = "POST_DISCONNECT_SCHEDULE_RESPONSE";
export const POST_DISCONNECT_SCHEDULE_FAIL = "POST_DISCONNECT_SCHEDULE_FAIL";

export const PUT_DISCONNECT_SCHEDULE = "PUT_DISCONNECT_SCHEDULE";
export const PUT_DISCONNECT_SCHEDULE_RESPONSE = "PUT_DISCONNECT_SCHEDULE_RESPONSE";
export const PUT_DISCONNECT_SCHEDULE_FAIL = "PUT_DISCONNECT_SCHEDULE_FAIL";

export const DELETE_DISCONNECT_SCHEDULE = "DELETE_DISCONNECT_SCHEDULE";
export const DELETE_DISCONNECT_SCHEDULE_RESPONSE = "DELETE_DISCONNECT_SCHEDULE_RESPONSE";
export const DELETE_DISCONNECT_SCHEDULE_FAIL = "DELETE_DISCONNECT_SCHEDULE_FAIL";

export const POST_BATCH_DISCONNECT_SCHEDULES = "POST_BATCH_DISCONNECT_SCHEDULES";
export const POST_BATCH_DISCONNECT_SCHEDULES_RESPONSE = "POST_BATCH_DISCONNECT_SCHEDULES_RESPONSE";
export const POST_BATCH_DISCONNECT_SCHEDULES_FAIL = "POST_BATCH_DISCONNECT_SCHEDULES_FAIL";

export const RESET = "RESET";

export function get(searchParams = {}, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_DISCONNECT_SCHEDULES,
      isLoading: isLoading,
    });

    const queryParams = {
      ...searchParams,
      page: searchParams.page !== undefined ? searchParams.page : 1,
      limit: searchParams.limit !== undefined ? searchParams.limit : 10,
    };

    return axios
      .get("/disconnectschedule", { params: queryParams })
      .then((res) => {
        dispatch({
          type: GET_DISCONNECT_SCHEDULES_RESPONSE,
          disconnectSchedules: res.data.data || [],
          total: res.data.total || 0,
          page: parseInt(queryParams.page),
          limit: parseInt(queryParams.limit),
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DISCONNECT_SCHEDULES_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_DISCONNECT_SCHEDULES,
      isLoading: isLoading,
    });

    return axios
      .get(`/disconnectschedule/${uuid}`)
      .then((res) => {
        const disconnectSchedule = res.data;
        dispatch({
          type: GET_DISCONNECT_SCHEDULES_RESPONSE,
          disconnectSchedules: { items: [disconnectSchedule], totalRows: 1 },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DISCONNECT_SCHEDULES_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function post(disconnectSchedule, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_DISCONNECT_SCHEDULE,
      isLoading,
    });

    return axios
      .post("/disconnectschedule", disconnectSchedule)
      .then((response) => {
        dispatch({
          disconnectSchedule: response.data,
          type: POST_DISCONNECT_SCHEDULE_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: POST_DISCONNECT_SCHEDULE_FAIL,
          error: error,
        });
      });
  };
}

export function put(disconnectSchedule, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: PUT_DISCONNECT_SCHEDULE,
      isLoading,
    });

    const { uuid, ...schedulePayload } = disconnectSchedule;

    return axios
      .put(`/disconnectschedule/${uuid}`, schedulePayload)
      .then((response) => {
        dispatch({
          disconnectSchedule: response.data,
          type: PUT_DISCONNECT_SCHEDULE_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: PUT_DISCONNECT_SCHEDULE_FAIL,
          error: error,
        });
      });
  };
}

export function deleteDisconnectSchedule(uuid, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: DELETE_DISCONNECT_SCHEDULE,
      isLoading,
    });

    return axios
      .delete(`/disconnectschedule/${uuid}`)
      .then((response) => {
        dispatch({
          type: DELETE_DISCONNECT_SCHEDULE_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_DISCONNECT_SCHEDULE_FAIL,
          error: error,
        });
      });
  };
}

export function postBatch(disconnectSchedules, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_BATCH_DISCONNECT_SCHEDULES,
      isLoading,
    });

    return axios
      .post("/disconnectschedule/batch", { schedules: disconnectSchedules })
      .then((response) => {
        dispatch({
          type: POST_BATCH_DISCONNECT_SCHEDULES_RESPONSE,
          schedules: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: POST_BATCH_DISCONNECT_SCHEDULES_FAIL,
          error: error,
        });
      });
  };
}

export function reset() {
  return {
    type: RESET,
  };
}
